import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { requireOfficeAccess } from '@/features/auth/utils/require-office-access';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { TeacherInactivationListPage } from '@/features/teacherInactivations/pages/TeacherInactivationListPage';
import { teacherInactivationSearchSchema } from '@/features/teacherInactivations/types/teacherInactivation.types';

export const Route = createFileRoute('/_auth/settings/teacher-inactivations/')({
  beforeLoad: requireOfficeAccess,
  validateSearch: teacherInactivationSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="Teacher Inactivation">
      <Suspense fallback={<PageLoader />}>
        <TeacherInactivationListPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
